import { apiClient } from '@lib/axios';

import type { UpdateHoursRequest, UpdateHoursResponse } from '../types';

export async function updateBusinessHours(
  accountId: string,
  data: UpdateHoursRequest,
): Promise<UpdateHoursResponse> {
  const { data: response } = await apiClient.put<UpdateHoursResponse>(
    `/settings/accounts/${accountId}/hours`,
    data,
  );
  return response;
}
